import Store from 'lib/Store';
import Collection from 'lib/Collection';
import { ActionTypes as AuthActionTypes } from 'auth/AuthConstants';
import { ActionTypes as UserActionTypes } from 'user/UserConstants';
import { ActionTypes } from 'constants/PromptConstants';

class PromptStore extends Store {
  getInitialState() {
    return {
      prompts: new Collection(),
    };
  }

  hasDismissed(name: string) {
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'prompt' implicitly has an 'any' type.
    return !!this.state.prompts.find((prompt) => {
      return prompt.getAction() === name && prompt.getResponse() === 'dismissed';
    });
  }

  hasDismissedWithin(name: string, daysAgo: number = 0) {
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'prompt' implicitly has an 'any' type.
    return !!this.state.prompts.find((prompt) => {
      if (prompt.getAction() !== name || prompt.getResponse() !== 'dismissed') {
        return false;
      }

      if (daysAgo > 0) {
        return prompt.getRespondedAt() > Date.now() - daysAgo * 24 * 60 * 60 * 1000;
      }

      return true;
    });
  }

  getAvailable(name: string) {
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'prompt' implicitly has an 'any' type.
    return this.state.prompts.find((prompt) => {
      return prompt.getAction() === name && prompt.getResponse() !== 'dismissed';
    });
  }

  getPrompt(name: string) {
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'prompt' implicitly has an 'any' type.
    return this.state.prompts.find((prompt) => {
      return prompt.getAction() === name;
    });
  }

  handleDispatch(action: any): void {
    switch (action.type) {
      case AuthActionTypes.AUTH_SUCCESS:
      case UserActionTypes.LOAD_USER:
        this.handleAuth(action.user);
        break;
      case ActionTypes.PROMPT_DISMISSED:
        this.handleDismissed(action.prompt);
        break;
      case ActionTypes.EXISTING_PROMPT_DISMISSED:
        // Just emit a change because the model is already in the store,
        // and has been mutated.
        this.emitChange();
        break;
      default:
        break;
    }
  }

  handleAuth(user: any): void {
    this.state.prompts = user.getRecentPrompts() || new Collection();
    this.emitChange();
  }

  handleDismissed(prompt: any): void {
    this.state.prompts.add(prompt);
    this.emitChange();
  }
}

export default new PromptStore();
